import { Dialog, DialogContent } from "@mui/material";

import CalendarModal from "./CalendarModal";

function OperatorsTableInfoModal({
  open,
  onClose,
  modalType,
  modalRef,
  onDateSelect,
  initialDate,
}) {
  const renderContent = () => {
    switch (modalType) {
      case "calendar":
        return (
          <CalendarModal
            onClose={onClose}
            onDateSelect={onDateSelect}
            initialDate={initialDate}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      ref={modalRef}
      maxWidth="sm"
      fullWidth
    >
      <DialogContent>{renderContent()}</DialogContent>
    </Dialog>
  );
}

export default OperatorsTableInfoModal;
